import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "dropdown", "pills"]
  static values = { options: Array, selected: Array }

  connect() {
    this.selected = new Set(this.selectedValue.map(String))
    this.render()
    this.onOutsideClick = this.handleOutsideClick.bind(this)
    document.addEventListener("click", this.onOutsideClick)
  }

  disconnect() {
    document.removeEventListener("click", this.onOutsideClick)
  }

  // Opens the dropdown with every still-available option, even without a query.
  open() {
    this.filter()
  }

  filter() {
    const query = this.inputTarget.value.toLowerCase().trim()
    const available = this.optionsValue.filter(o => !this.selected.has(String(o.id)))
    const matches = query ? available.filter(o => o.name.toLowerCase().includes(query)) : available
    this.dropdownTarget.hidden = matches.length === 0
    this.dropdownTarget.innerHTML = matches
      .map(o => `<li class="tag-picker__option px-3 py-2 cursor-pointer hover:bg-surface-low" data-id="${o.id}" data-action="click->tag-picker#add">${o.name}</li>`)
      .join("")
  }

  add(event) {
    const id = event.currentTarget.dataset.id
    this.selected.add(String(id))
    this.inputTarget.value = ""
    this.render()
    this.open()
  }

  remove(event) {
    const id = event.currentTarget.dataset.id
    this.selected.delete(String(id))
    this.render()
  }

  keydown(event) {
    if (event.key === "Backspace" && this.inputTarget.value === "" && this.selected.size > 0) {
      const last = Array.from(this.selected).pop()
      this.selected.delete(last)
      this.render()
    }
  }

  close() {
    this.dropdownTarget.hidden = true
  }

  handleOutsideClick(event) {
    if (!this.element.contains(event.target)) this.close()
  }

  render() {
    this.pillsTarget.innerHTML = Array.from(this.selected).map(id => {
      const option = this.optionsValue.find(o => String(o.id) === id)
      return option ? `<li class="tag-picker__pill inline-flex items-center gap-1 rounded-full bg-primary-100 text-primary-700 px-3 py-1 text-sm" title="${option.name}">${option.name}<button type="button" class="tag-picker__pill-remove ml-1 text-primary-700 hover:text-primary-900" data-id="${id}" data-action="click->tag-picker#remove">&times;</button></li>` : ""
    }).join("")
    this.element.querySelectorAll("input[type=checkbox]").forEach(cb => {
      cb.checked = this.selected.has(String(cb.value))
    })
  }
}
